/* istanbul ignore file */

export const ARRIVE_ON_OR_BEFORE = 'Estimated to arrive on or before';
export const YOUR_DATE = 'your date';
export const SHOW_MORE_DATES = 'Show more dates';
export const SHOW_FEWER_DATES = 'Show less';
export const ARRIVE_BY_QUESTION = 'What does "arrive by" mean?';
// PLACEHOLDER: awaiting Design wording. The design's copy claims carrier times and delivery
// routes, which is not how the dates are derived: today plus the product's delivery days,
// counting every calendar day.
export const ARRIVE_BY_ANSWER =
  "Each date is an estimate. It is today's date plus the number of days the seller's quickest delivery usually takes. Weekends and bank holidays are counted as days, so an order may arrive later around them.";
// PLACEHOLDER: awaiting Design wording. "Guaranteed" may appear only while the guaranteed
// arrival day is on, since every other date is an estimate.
export const GUARANTEED_TO_ARRIVE_ON = 'Guaranteed to arrive on';
export const getGuaranteedArrivalToggleLabel = (dayName: string) =>
  `Guaranteed ${dayName} delivery`;
